
    
    <template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-if="!loading" my-2>
            <form @submit.prevent="update_users" autocomplete="off">
                <v-layout row wrap>
                    
        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="text" v-model="users.user_firebase_uid" :label="$store.getters.lang.data.user_firebase_uid"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        


        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="text" v-model="users.user_name" :label="$store.getters.lang.data.user_name"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        


        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="text" v-model="users.user_display_name" :label="$store.getters.lang.data.user_display_name"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        


        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="text" v-model="users.user_gender" :label="$store.getters.lang.data.user_gender"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        


        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="date" v-model="users.user_birth_date" :label="$store.getters.lang.data.user_birth_date"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        



            <v-flex xs12 lg2 xl2 md3 sm4>
            <v-select class="mx-1" clearable rounded filled :items="towns" v-model="users.town_id" outlined  item-text="town_id"
                            item-value="town_id" :return-object="false" :label="$store.getters.lang.data.town_id">
                        </v-select>
                        </v-flex>
            
        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="text" v-model="users.user_profile_picture" :label="$store.getters.lang.data.user_profile_picture"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        


        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="date" v-model="users.user_join_date" :label="$store.getters.lang.data.user_join_date"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        


        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="number" v-model="users.user_review_count" :label="$store.getters.lang.data.user_review_count"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        


        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="number" v-model="users.user_report_count" :label="$store.getters.lang.data.user_report_count"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        


        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="text" v-model="users.user_verified" :label="$store.getters.lang.data.user_verified"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        



            <v-flex xs12 lg2 xl2 md3 sm4>
            <v-select class="mx-1" clearable rounded filled :items="user_badges" v-model="users.user_badge_id" outlined  item-text="user_badge_name"
                            item-value="user_badge_id" :return-object="false" :label="$store.getters.lang.data.user_badge_id">
                        </v-select>
                        </v-flex>
                
    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn color="primary" rounded class="mx-1"  type="submit" x-large>{{$store.getters.lang.data.update_btn}}</v-btn>
                    </v-flex>    
                </v-layout>
            </form>
        </v-container>
        
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>

<script>
    import controller from './../../controller/users'
    export default {
        data() {
            return {
                users: {},
                id: '',
                loading: true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },

            }
        },
        computed: {
            
                    towns (){
                        return this.$store.getters.towns
                    },
                    
                    user_badges (){
                        return this.$store.getters.user_badges
                    },
                    
            
        },
        methods: {
            get_users() {
                this.loading = true
                controller.getOne(this.id).then(r =>{
                    this.users = r.data.row
                    this.loading = false
                }).catch(e =>{
                    console.log(e);
                })
            },
            update_users() {
                controller.update_users(this.users).then(r => {
                    if (r.data) {
                        this.snackbar = {
                            value: true,
                            text: 'Updated',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Not Updated',
                            color: 'error'
                        }
                    }
                })
            },
            
        },
        mounted() {
            this.id = this.$route.params.id
            this.get_users()
        },
    }
</script>
    
    